<template>
  <div class="point-festival-join root">
    <div class="banner">
      <img :src="kv" alt="Point Festival" />
    </div>

    <div class="action_segment">
      <div class="qty-row">
        <span class="qty-label">จำนวนสิทธิ์</span>
        <div class="stepper">
          <button class="step" :disabled="quantity <= 1" @click="changeQty(-1)">-</button>
          <span class="qty-value">{{ $toLocal(quantity) }}</span>
          <button class="step step-plus" :disabled="quantity >= maxQty" @click="changeQty(1)">+</button>
        </div>
      </div>
      <div v-if="luckyDraw" class="use-point">
        <span>คะแนนของคุณ {{ $toLocal(point) }}</span>
        <span>ใช้ {{ $toLocal(usePoint) }} คะแนน (สิทธิ์ละ {{ $toLocal(luckyDraw.redeemPoint) }})</span>
      </div>
      <button
        class="btn-festival btn-red"
        :disabled="!luckyDraw || !luckyDraw.isActive || $readOnly"
        @click="redeemClick"
        data-tag="point_festival_join"
      >
        ลุ้นรางวัล
      </button>
    </div>

    <!-- success -->
    <div v-if="success" class="success-overlay" :style="{ backgroundImage: `url(${kv}), linear-gradient(180deg, #d81e1e 0%, #a5000c 100%)` }">
      <div class="success-card">
        <svg class="smile" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="44" fill="none" stroke="#8dc63f" stroke-width="6" />
          <circle cx="35" cy="40" r="6" fill="#8dc63f" />
          <circle cx="65" cy="40" r="6" fill="#8dc63f" />
          <path d="M28 60 Q50 82 72 60" fill="none" stroke="#8dc63f" stroke-width="6" stroke-linecap="round" />
        </svg>
        <div class="success-text">
          ลุ้นรางวัลเรียบร้อย
          <br />ขอบคุณที่ร่วมสนุก
        </div>
        <div class="success-sub">ประกาศผู้โชคดี {{ announceText }}</div>
      </div>
      <div class="success-actions">
        <button class="btn-festival btn-dark" @click="goHome" data-tag="point_festival_home">
          กลับหน้าแรก
        </button>
        <button class="btn-festival btn-red" @click="joinAgain" data-tag="point_festival_again">
          ลุ้นรางวัล
        </button>
      </div>
    </div>

    <transition name="list">
      <PinCodeInput
        v-if="enterPincode"
        v-on:already-pin="alreadyPin"
        v-on:close="closePinInput"
        :title="'กรุณาใส่ PIN'"
        :reset_pin="'ลืม PIN ?'"
        v-on:reset-pin="resetPin"
        :pin_length="6"
      />
    </transition>
  </div>
</template>

<script>
import PinCodeInput from "@/components/pinCodeInput";
import {
  POINT_FESTIVAL,
  POINT_FESTIVAL_KV,
  fetchPointFestival,
  trackFestival,
  getAnnounceDate,
  formatThaiShortDate,
} from "@/helper/pointFestival";

export default {
  name: "pointFestivalJoin",
  components: { PinCodeInput },
  data() {
    return {
      luckyDraw: null,
      quantity: 1,
      enterPincode: false,
      success: false,
      kv: POINT_FESTIVAL_KV,
    };
  },
  computed: {
    point() {
      return this.$userData.point || 0;
    },
    usePoint() {
      return ((this.luckyDraw && this.luckyDraw.redeemPoint) || 0) * this.quantity;
    },
    canRedeem() {
      return this.luckyDraw && this.point >= this.usePoint;
    },
    maxQty() {
      const redeemPoint = this.luckyDraw && this.luckyDraw.redeemPoint;
      if (!redeemPoint) return 1;
      return Math.max(1, Math.floor(this.point / redeemPoint));
    },
    announceText() {
      return formatThaiShortDate(getAnnounceDate(this.luckyDraw));
    },
  },
  methods: {
    async init() {
      try {
        this.luckyDraw = await fetchPointFestival(this.$JWT);
        if (!this.luckyDraw) throw "point festival not found";
      } catch (error) {
        console.log(error);
        this.Swal.fire("", "ไม่พบข้อมูลกิจกรรม กรุณาลองใหม่ภายหลัง", "warning");
        this.$router.replace({ name: "point-festival" });
      }
    },
    changeQty(diff) {
      this.quantity = Math.min(this.maxQty, Math.max(1, this.quantity + diff));
    },
    redeemClick() {
      trackFestival("click_join", { quantity: this.quantity, point: this.point });
      if (!this.canRedeem) {
        this.alertMsg("POINT_NOT_ENOUGH");
        return;
      }
      this.enterPincode = true;
    },
    alreadyPin(pinCodeInput) {
      this.enterPincode = false;
      trackFestival("pin_entered", { quantity: this.quantity });
      this.joinRedeem(pinCodeInput);
    },
    closePinInput(val) {
      if (val) {
        this.enterPincode = false;
      }
    },
    async joinRedeem(pincode) {
      try {
        window.loading(true);
        const res = await fetch(
          process.env.VUE_APP_API_URL + "/lucky_draws/" + this.luckyDraw.id + "/join",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$JWT}`,
            },
            body: JSON.stringify({
              quantity: this.quantity,
              pincode: pincode.toString(),
            }),
          }
        );
        const body = await res.json();
        window.loading(false);
        trackFestival(res.status == 200 ? "join_success" : "join_fail", {
          quantity: this.quantity,
          points_used: this.usePoint,
          status: res.status,
          message: (body && body.message) || "",
        });
        switch (res.status) {
          case 200:
            this.success = true;
            window.scrollTo(0, 0);
            this.refreshPoint();
            return;
          case 422:
          case 403:
            this.alertMsg(body.message);
            break;
          default:
            this.alertMsg("error");
        }
      } catch (error) {
        window.loading(false);
        console.log(error);
        this.alertMsg("error");
      }
    },
    async refreshPoint() {
      try {
        const res = await fetch(process.env.VUE_APP_API_URL + "/me", {
          headers: {
            Authorization: `Bearer ${this.$JWT}`,
          },
        });
        if (res.status == 200) {
          this.$store.dispatch("setUserData", await res.json());
        }
      } catch (error) {
        console.log(error);
      }
    },
    alertMsg(status) {
      trackFestival("alert", { message: status });
      switch (status) {
        case "POINT_NOT_ENOUGH":
          this.Swal.fire("คะแนนไม่เพียงพอ", "", "warning");
          break;
        case "End of redeem period":
        case "NOT_IN_LUCKY_DRAW_PERIOD":
          this.Swal.fire("ไม่อยู่ในช่วงเวลาร่วมกิจกรรม", "ร่วมสนุกได้ " + POINT_FESTIVAL.info.period, "warning");
          break;
        case "INVALID_PINCODE":
          this.Swal.fire({
            title: "PIN ไม่ถูกต้อง",
            text: "กรุณาลองใหม่ หรือติดต่อเจ้าหน้าที่",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#eaa200",
            cancelButtonColor: "#a7a7a7",
            confirmButtonText: "Reset Pin",
            cancelButtonText: "กลับ",
          }).then((result) => {
            if (result.value) {
              this.resetPin();
            }
          });
          break;
        default:
          this.Swal.fire({
            html: `ลุ้นรางวัลไม่ได้ในขณะนี้<br>กรุณาเข้าใช้ใหม่ภายหลัง หรือติดต่อเจ้าหน้าที่`,
            icon: "warning",
          });
      }
    },
    resetPin() {
      this.$router.replace({
        name: "otp",
        params: {
          route_back: this.$route,
          route_after_success: {
            name: "set-pin",
            params: {
              route_after_success: this.$route,
            },
          },
        },
      });
    },
    goHome() {
      try {
        trackFestival("click_back_home");
      } catch (error) {
        console.log(error);
      }
      this.success = false;
      // fall back to a full load if the in-app navigation is aborted
      this.$router.replace({ name: "rewards" }).catch((error) => {
        console.log(error);
        window.location.replace(this.$router.resolve({ name: "rewards" }).href);
      });
    },
    joinAgain() {
      trackFestival("click_join_again");
      this.quantity = 1;
      this.success = false;
    },
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.init();
    // no header on this page, so load the point balance here
    this.refreshPoint();
    window.loading(false);
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/pointFestival.scss";

.root {
  font-size: 16px;
  // fill the space below the banner with the festival red
  background: linear-gradient(180deg, #d81e1e 0%, #a5000c 100%);
  min-height: 100vh;
  padding-bottom: 170px;
  position: relative;
  // blend the bottom of the key visual into the background
  .banner img {
    -webkit-mask-image: linear-gradient(to bottom, #000 85%, transparent);
    mask-image: linear-gradient(to bottom, #000 85%, transparent);
  }
}

.action_segment {
  padding: 12px 15px 16px;
  width: 100%;
  max-width: 450px;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);
  .btn-festival {
    width: 100%;
  }
}

.qty-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .qty-label {
    font-weight: 700;
  }
}

.stepper {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #ddd;
  border-radius: 22px;
  padding: 2px;
  .step {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: #e0e0e0;
    color: #333;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    padding: 0 0 2px;
    &.step-plus {
      background: #8dc63f;
      color: #fff;
    }
    &:disabled {
      opacity: 0.4;
    }
  }
  .qty-value {
    min-width: 56px;
    text-align: center;
    font-size: 18px;
  }
}

.use-point {
  display: flex;
  justify-content: space-between;
  margin: 6px 0 10px;
  font-size: 13px;
  color: #666;
}

.success-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1040;
  width: 100%;
  max-width: 450px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  background-size: 100% auto, cover;
  background-position: top center;
  background-repeat: no-repeat;
  .success-card {
    background: #fff;
    border-radius: 24px;
    padding: 32px 16px;
    text-align: center;
    .smile {
      width: 110px;
      height: 110px;
      margin-bottom: 20px;
    }
    .success-text {
      font-size: 20px;
      font-weight: 500;
      line-height: 1.5;
    }
    .success-sub {
      margin-top: 12px;
      font-size: 16px;
    }
  }
  .success-actions {
    display: flex;
    gap: 12px;
    .btn-red {
      box-shadow: inset 0 0 0 2px #fff;
    }
  }
}
</style>
